// extracted by mini-css-extract-plugin
export var quantityInput = "_gn-0";